"use client"
import React, { useState } from 'react';
import Header1 from '@/components/header4/page';
import { IoIosArrowForward } from "react-icons/io";
import { Oswald } from 'next/font/google';
import Footer from '@/components/footer/page';
import Loader from '@/components/LoaderFile/Loader';
import { Suspense } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import Link from 'next/link';
import { title } from 'process';
const oswald = Oswald({ weight: ['400', '500', '700'], subsets: ['latin'] })

function Faq() {

  const [selectedDropdown, setSelectedDropdown] = useState(null);
  const [selectedDropdown1, setSelectedDropdown1] = useState(null);
  const [selectedDropdown2, setSelectedDropdown2] = useState(null);
  const [selectedDropdown3, setSelectedDropdown3] = useState(null);
  const [selectedDropdown4, setSelectedDropdown4] = useState(null);
  const [selectedDropdown5, setSelectedDropdown5] = useState(null);
  const [selectedDropdown6, setSelectedDropdown6] = useState(null);
  const [selectedDropdown7, setSelectedDropdown7] = useState(null);
  const [selectedDropdown8, setSelectedDropdown8] = useState(null);
  const [selectedDropdown9, setSelectedDropdown9] = useState(null);
  const [selectedDropdown10, setSelectedDropdown10] = useState(null);
  const [loading, setLoading] = useState(false);

  const dropdownOptions = [
    { id: 1, title: 'Who do I reach out to, if I have a question or issue with my order?', content: <>Our Customer Care Team are trained professionals in the resale ticket industry. They are available to assist to you 7 days a week from 9:30 am - 10pm EST. Our Customer Care Team has access to all the information associated with your order which is stored in our computer system. If you have a question,<a href="/contactus" className='text-blue-500'><b className='text-blue-500'> please visit our CONTACT US page</b></a> to connect with us via email or phone support. We kindly ask that you do not reach out to Jagger Long - Owner of Karma Tickets - on Facebook messenger to ask him a question unless you have read this FAQ’s page in its entirety, have spoken to our Customer Care Team, our team was unable to assist you and its an emergency; such as you are unable to enter the venue due to an issue with your tickets. Please note, that there is also no guarantee that you will be able to instantly connect with Jagger Long,which is another reason to make it your priority to reach out the our Customer Care Team. Our Customer Care team is waiting to assist you!</> },
    { id: 2, title: 'I just placed an order, “What’s Next?”', content: 'It is very important to understand that once you place an order, this does not mean you are guaranteed the tickets. To ensure there are no double sales and issues with tickets, we implement a “Pending Order” status. This means that we have received your order and we are in the process of making sure the tickets are 100% available and did not sell on another platform just before your order attempt. You will be sent a “Pending Order” email to acknowledge we received your order. Once we receive confirmation from our seller that the tickets you ordered are available to deliver to you, you will receive a “Confirmation Order” email. This confirmation email will not be your tickets. You will receive an additional email that will include your tickets.' },
    { id: 3, title: 'How long is my order in ‘Pending’ status before I receive my ‘Confirmation’ Email?', content: 'Most times buyers will be notified within minutes that their order has been confirmed. Unfortunately for various reasons, some orders will not receive an instant confirmation email. If you just placed an order for an event happening on the day of your order, it is strongly suggested that you reach out to our Customer Care Team 5 minutes after you placed your order. On our new website/app. Fans can now monitor the status of their orders in their profile on our website/app. If after 5 minutes you still see your order in ‘Pending’ status, it is best to follow these instructions when you contact our Customer Care Team: 1) Phone call our Customer Care Team. If one of our customer service agents does not answer your call, you must leave a message with your phone number, your order number & and a short explanation of the reason for your phone call. 2) If you left a phone message (along with your order number), it is also suggested that you EMAIL the Customer Care Team and make sure to leave your order number as a reference. It is to your benefit to leave both a phone message and an email, especially when you purchase last-minute tickets.' },
    { id: 4, title: 'How will it take for my tickets be sent to me via email after I received my “Confirmation Order” email?', content: 'Every order is different. All tickets will be sent to the email associated with your order. Most times tickets are sent via Ticketmaster transfer. Sometimes barcode images are sent. Other times a link with an attachment with your tickets will be sent. If you have an issue with your ticket transfer, downloading your tickets, opening up any link that is sent to you or any other ticket related issue, we remind you to reach out to our Customer Care Team via email or phone support..' },
    { id: 5, title: 'Do I need a Ticketmaster account before I place my order or to receive my tickets?', content: 'You do not need a Ticketmaster account to place your order. You also do not need a Ticketmaster account to accept your tickets. When a Ticketmaster link is sent for you to download your tickets into your Ticketmaster account, you can follow the link and CREATE your account at this time. It is however suggested that you create your Ticketmaster account at the very least right after your order. This will make your downloading your tickets experience into your Ticketmaster account process much faster.' },
    { id: 6, title: 'Do I need to download the MLB app before I purchase tickets for an MLB game?', content: 'You are welcome to download the MLB app before your purchase. Please feel free to visit our CONTACT US to reach out to our Customer Care Team and ask them for more specific details of your order, such as do you require the MLB app.' },
    { id: 7, title: 'I called Customer Care phone number but no one answered. What do I do now?', content: `Like any Customer Care phone line for any business, there is no guarantee that our Customer Care Team will be able to answer every call all day long. You must leave a message with your order number. It is also suggested that after you leave a phone message with your order number you also email our Customer Care Team. Please don't forget to leave your order number. Leaving a phone message + sending an email may speed up the time our team gets back to you. If you are reaching out to discuss an issue at the game and time is of the essence, it is even more important that you leave both a phone call message and an email. Once you call and leave a message as well as email, it is also suggested that you keep calling back until someone does answer or we return your phone/email message. It is extremely important that you leave a message with your order number the very first time you call. We understand as a fan you may be panicking and feel desperate to speak to someone, however getting frustrated and hanging up without leaving us a detailed message with your order number does not help you out. Please be patient. Rest assured, we will return a call. If for example, 5 minutes go by, it is suggested that you reply back to the email you sent, mention you left a phone message plus this email message, that it is an emergency because your event is about to start, that no one has gotten back to you in the last 5 minutes and that you need immediate assistance. With your email communications, if there are complaints about our response time, you will have a written track record of your emails. As a fyi, we record all phone calls that our Customer Care team has with customers + all voicemail messages and the time of messages customers leave. When a customer calls our Customer Care team and chooses not to leave us a message, we also have on record the call that was placed + no message that was left.` },
    { id: 8, title: 'I placed an order and received an email stating “Your Order Was Not Able to be Fulfilled. Why is this? What should I do next?', content: 'As an online company, we require all orders to pass a 3 point fraud check. If an order fails all 3 of our check system, an order is “Not Able to be Fulfilled.” The most common error is when fans enter an email in the order that is not associated with day to day online purchases made with the Credit Card used to place the order. It is suggested that you try again and make sure all your information is correct. If your 2nd attempt is also “Unable to be Fulfilled,” please reach out to our Customer Care Team on our CONTACT US page.' },
    { id: 9, title: 'I placed an order and an error message pops up', content: 'As an online company that sells tickets on the resale market, sometimes the tickets you want to purchase have recently sold on our site or another site. Unfortunately for various reasons, the ticket option may still be listed on our system. Since the system cannot find your tickets to complete the order, you may experience an “error message.” We encourage you to attempt to purchase a different set of tickets if an error message pops up. Sorry for the inconvenience.' }
  ];

  // const handleDropdownClick = (id: any) => {
  //   setSelectedDropdown(id);
  //   // Logic to display content based on dropdown id
  // };
  // const handleDropdownClick = (id:any) => {
  //   setSelectedDropdown(selectedDropdown === id ? null : id);
  // };

  const handleDropdownClick = (id: any) => {
    setSelectedDropdown((prevSelected) => (prevSelected === id ? null : id));
  };

  const dropdownOptions1 = [
    { id: 1, title: 'Why can’t I add more than one set of tickets to my shopping cart?', content: 'Different tickets come from different sellers, subject to varying delivery methods and fulfillment timeframes.' },
    { id: 2, title: 'Why are there restrictions on the quantity of tickets I can select?', content: 'We comply with seller specifications regarding ticket quantities purchasable.' },
    { id: 3, title: 'How are tickets on your site delivered?', content: 'Delivery methods vary per listing, including e-tickets, physical tickets, paperless tickets, transfers, and will call/local pickups' },
    { id: 4, title: 'How do I check the status of my order?', content: 'You will receive an order confirmation email once your ticket purchase is confirmed.' },
    { id: 5, title: 'If I purchase tickets for an event that takes place in the next 24-48 hours, will I still receive my tickets in time?', content: 'Delivery methods are noted on each listing; various delivery options are available based on the timeframe.' },
  ];

  const handleDropdownClick1 = (id: any) => {
    setSelectedDropdown1(id);
    // Logic to display content based on dropdown id
  };
  
  const dropdownOptions2 = [
    { id: 1, title: 'Will my seats be next to one another?', content: 'Reserved seating tickets in the same transaction will be adjacent, unless otherwise specified.' },
    { id: 2, title: 'What do Even/Odd and Consecutive Seating mean?', content: 'Describes different seating configurations depending on the venue.' },
    { id: 3, title: 'What else might I need to know about my tickets?', content: 'Additional amenities or information are listed in ticket details/notes.' },

  ];

  const handleDropdownClick2 = (id: any) => {
    setSelectedDropdown2(id);
    // Logic to display content based on dropdown id
  };
  
  const dropdownOptions3 = [
    { id: 1, title: 'How are ticket prices determined?', content: 'Prices are based on market value, not face value.' },
    { id: 2, title: 'Are the ticket prices displayed online for a single ticket or for a group of tickets?', content: 'Prices displayed per ticket; full breakdown shown during checkout.' },
    { id: 3, title: 'Are there additional fees charged?', content: 'Service and/or delivery charges may apply to each order.' },

  ];

  const handleDropdownClick3 = (id: any) => {
    setSelectedDropdown3(id);
    // Logic to display content based on dropdown id
  };

  
  const dropdownOptions4 = [
    { id: 1, title: 'If I am located abroad, what currency will I be charged in?', content: 'All transactions processed in USD.' },
    { id: 2, title: 'When will my credit card be charged?', content: 'Charged once the seller confirms the order.' },
    { id: 3, title: 'What company name will I see on my credit card statement?', content: 'Ticket Group 9724459061' },

  ];

  const handleDropdownClick4 = (id: any) => {
    setSelectedDropdown4(id);
    // Logic to display content based on dropdown id
  };

  
  const dropdownOptions5 = [
    { id: 1, title: 'The name on the ticket is not mine; will I have issues at the event?', content: 'Name on the ticket doesnot need to match attendee; normal industry practice.' },
    { id: 2, title: 'Can I bring items into the event?', content: 'Venue discretion; contact them directly for details.' },
    { id: 3, title: 'My physical tickets were lost/stolen, can I have them resent?', content: 'Not responsible for lost/stolen tickets; contact support for assistance.' },

  ];

  const handleDropdownClick5 = (id: any) => {
    setSelectedDropdown5(id);
    // Logic to display content based on dropdown id
  };

  
  const dropdownOptions6 = [
    { id: 1, title: 'What if my event is canceled or does not occur?', content: 'Refunds issued for canceled events within 5 days; contact support if not received.' },
    { id: 2, title: 'Will I get a refund if my event is postponed?', content: 'Refunds only for canceled events; postponed events tickets usually valid for rescheduled date.' },
    { id: 3, title: 'Can I cancel an order I have already placed?', content: 'No, all sales are final.' },
    { id: 4, title: 'Can I exchange tickets for a different quantity or date?', content: 'No, all sales are final.' },


  ];

  const handleDropdownClick6 = (id: any) => {
    setSelectedDropdown6(id);
    // Logic to display content based on dropdown id
  };


  const dropdownOptions7 = [
    { id: 1, title: 'I see tickets on your website but they are above my budget. Do you / will you have anything else available at a cheaper cost?', content: 'Karma Tickets is an online resale ticket business. The website was built to give fans the opportunity to look up various ticket options and price drops. It is your job as a fan to keep on eye on event listings and pricing. Good luck!' },
    {
      id: 2,
      title: 'I can’t find tickets for a certain event. Will you be getting tickets for this event?',
      content: (
        <>
          <p>Many fans jump to our resale ticket website when they hear tickets for an event will be going on sale. Majority of the time, fans will not see tickets listed on our website until the pre-sale date has arrived for that event. It is a fan's responsibility to research the internet to know when this date is. Fans can search for an event on Ticketmaster or any other primary source the tickets for the event are released on and they should be able to read when the pre-sale release date is. If tickets are not displayed on our website after the day & time that pre-sale tickets were sold, they can come back to visit our website to see if they find any tickets listed after the general public release date happens.</p>

          <br />

          <p>If fans know an event has already had its general public sale and they see no tickets on our website, they can visit our CONTACT US page on this website and ask our Customer Care Team if they can check to see if any tickets can be listed for this event. The easiest way to do this would be to use our EMAIL feature to send your request. You can write something like, “I don’t see tickets on your website for Coldplay in Toronto. Can you please check to see if you have any tickets that can be listed on the website? Thanks”</p>

          <br />

          <p>REMINDER: Karma Tickets is in the resale ticket industry. Smaller events with no resale ticket interest, such as listening to a band at your local bar, are typically not found on our website.</p>
        </>
      )
    },

    { id: 3, title: 'Can you tell me the seat numbers of the seats before I purchase my tickets?', content: 'We understand fans often want to know the seats numbers before purchasing their tickets. Unfortunately for various reasons, seat numbers are not displayed on Karma Tickets, Once your order is confirmed and tickets are emailed to you, you will then know what seats numbers you are assigned. We are sorry for this inconvenience.' },
    { id: 4, title: 'How can I find out which seats are aisle seats?', content: 'For various reasons, aisle seats are not displayed on Karma Tickets. We understand fan want to purchase aisle seats only. If aisle seats are your desire, Karma Tickets is unable to assist you with feature.' },
    { id: 5, title: 'I want to purchase Accessible / Wheel Chair seats. How do I know which seats are Accessible Seating?', content: 'Most events in the resale ticket industry do not offer Accessible/Wheel Chair ticket options. Occasionally fans can find Accessible/Wheel Chair tickets listed on Karma Tickets for various events. If a listing is an Accessible/Wheel Chair seat option, fans will see a a blue wheel chair logo displayed on a listing. Unfortunately if you cannot find any blue wheel chair logos on any of our listings, we do not have any available for sale.We wish you all the best on your search.' },
    { id: 6, title: 'How can you have seats for sale for an event that are “Ticketmaster non transferable” tickets?', content: 'All tickets on our website come with a guarantee. If you want additional confirmation that tickets which are available on our website are indeed valid, feel free to reach out to our Customer Care Team by visiting our “Contact Us” page on our website.' },
    { id: 7, title: 'How do you know if a certain event is all ages or 19+ ?', content: 'We suggest you try Ticketmaster or the main primary source of tickets for the event you are inquiring about and read their event info section. You can also reach out to our Customer Care Team by visiting our “Contact Us” page on our website.' },
    { id: 8, title: 'What does it mean if a ticket listing reads “GA” or “GA FLOORS” ?', content: 'GA = General Admission. Typically General Admission tickets are standing room general admission. For more clarification, feel free to contact our Customer Care Team by visiting our “Contact Us” page on our website.' },
    { id: 9, title: 'A listing says there are 3 tickets available but I want to purchase only 2 tickets. Why does it only give me an option to purchase 1 or all 3 tickets from the listing?', content: 'Most seller listing tickets on the resale tickets market choose not to be stuck with having only a single ticket left from their set. Therefore, sellers will set their listings that prevent only one ticket remaining to be purchased.' },
    { id: 10, title: 'I want to purchase 9 tickets but the listing says I can only purchase 1-8 or 10 tickets of the 10 total tickets listed on the option.', content: '*Same answer as above' },
    { id: 11, title: 'The listing says “Rear View.” What does this mean?', content: 'Some artist/bands choose to open up sections to be sold that are to the side or rear of the front of stage. “Rear View” the tickets listed are considered “Rear View” of the stage. This is noted to make sure there are no upset fans sitting in “Rear View” seats that were expecting a front of the stage. Seats that are “Rear View” labeled are to give fans a warning that the view is on the rear of the stage and not from the front of the stage. Most times fans will noticed seats with a “Rear View” label are cheaper than other sections.' },
    { id: 12, title: 'The listing says “Obstruction / Obstructed View.” What does this mean?', content: 'Some sections and rows may have an obstruction from the seat. If you are uncertain about purchasing tickets that are labeled as “Obstructed View,” purchasing tickets with this label is done so at your own risk.' },
    { id: 13, title: 'Why does it say tickets will be delivered at a date in the future or 24-72 hours before an event.', content: 'There are various reasons why you may read this on a specific listing or event. Sometimes artists and the primary ticket source (such as Ticketmaster) make this their choice. Sometimes one of ticket sellers, for various reasons, will not have the tickets they listed ready to be shipped immediately. If this is a concern for you or you want to try to find out more information, you are welcome to visit our CONTACT US page to reach out to our Customer Care Team via email or phone support and ask for additional information.' },
  ];

  // const handleDropdownClick7 = (id: any) => {
  //   setSelectedDropdown7(id);
  //   // Logic to display content based on dropdown id
  // };

  const handleDropdownClick7 = (id: any) => {
    setSelectedDropdown7(selectedDropdown7 === id ? null : id);
  };

  
  const dropdownOptions8 = [
    { id: 1, title: 'I cant find my tickets in my Karma Tickets profile under “my events.” Why is this?', content: '“My Events” only displays your upcoming events. Your tickets are NOT stored in this section. Fans will still have to retrieve their tickets in the format that was sent to them from their online purchase. This could be a link, Ticketmaster transfer, QR code or any other valid ticket delivery that our sends out to Karma customers via email.' },
    { id: 2, title: 'Do you have tickets for so and so event?', content: `The easiest way to find out is simply by visiting our website and using our SEARCH BUTTON feature. You can type in the team, artist, band, or venue name to see a complete listing of ticket options for various events. If you are having difficulty finding an event based on the artist's name, we suggest searching for the venue's name and then scrolling down the list that appears. Often fans misspell a name or the artist is an opening act and for some reason, their name does not show up when searching for their name.` },
    { id: 3, title: 'Will you be getting tickets to “band name/artist name” ?', content: 'As a reminder, Karma Tickets is in the resale ticket business. Tickets for most major events are typically found on our website. Fans can often find tickets listed on our site once pre sale dates have been launched. Fans have to do their own research on google to know when those dates are for the event they want to attend. If you dont see any tickets listed during presale, you can try again on the date of public sales from the primary ticket source (such as ticketmaster) happen. If you still dont see any tickets for an event, feel free to visit our Contact Us page and reach out to our Customer Care Team via phone or email.' },
    {
      id: 4, title: 'Will prices drop closer to the date of an event?', content: `Karma Tickets cannot answer this question for fans. The market demand of each
                                                                                  demand dictates pricing, not Karma Tickets. As an event gets closer and seats are not
                                                                                  selling out, fans will often see prices drop. Karma Tickets has a new feature that
                                                                                  displays how many tickets remain for each event to help give fans a better
                                                                                  understanding of the market. Fans can monitor the number of seats being sold. If fans
                                                                                  see the total number of tickets listed are not moving that much, this is a good indicator
                                                                                  that the market for that event is low and fans can expect to see prices start to drop.
                                                                                  Karma Tickets will never say prices are guaranteed to drop. Sometimes on our
                                                                                  Facebook group, you will see posts being made sharing tips of prices dropping for
                                                                                  certain events, especially when we notice prices dropping a lot.` },
    { id: 5, title: 'I can’t attend an event I bought tickets for. Can you help me sell them?', content: 'Although we do appreciate thinking of Karma Tickets, we do not offer a service to list tickets for the general public. Karma Tickets focuses on only listing tickets by season seat holders and ticket brokers who have registered business accounts with us. Karma Tickets' },
    {
      id: 6, title: 'I have tickets for sale. Are you interested in buying them?', content: `Karma Tickets is not interested in purchasing tickets from the general public unless a
                                                                                            seller is offering to sell their tickets well below the market value cost. If you check out
                                                                                            the market value pricing for an event you are looking to sell tickets for and see that you
                                                                                            are willing to sell them well below the market value, you are welcome to visit our
                                                                                            Contact Us page and send us an email with the following details: Event name/date of
                                                                                            the event/section/row/number of seats and the price PER SEAT you are willing to sell
                                                                                            them at. Your email will be forwarded to someone who will then reach out to you if they
                                                                                            are interested in purchasing your tickets from you. If you do not hear back from us, this
                                                                                            would indicate that we are not interested in buying your tickets.`},
    { id: 7, title: 'Can I post my tickets for sale on your Karma Tickets Facebook group?', content: 'No, sorry. Our Karma Tickets Facebook group is our social media business page and we do not allow our network to be a source for others to sell their tickets on.' },
    { id: 8, title: 'Where do you suggest I can sell my tickets?', content: 'You can list your tickets for sale on the major resale ticket websites, post on your own social media platforms or on various social media community pages.' },
    {
      id: 9, title: 'Are you tickets priced in Canadian dollars?', content: <> <p>To provide fans with a large inventory of ticket options for all major events around the world and to offer our customers the highest quality of customer service in the resale ticket industry, Karma Tickets has partnered up with a USA company. All prices on our site are listed in CDN, however, since our USA partner manages ticket inventory and customer service, including processing Credit Card purchases, all orders will be processed in USD to the equivalent of the CDN price you see listed. On our checkout page, you will see the CDN total + disclaimer indicating the days exchange rate and what your order will be charged in USD.
      </p>
        <br />
        <p>
          Please note, your bank/bank credit card may assess a small International processing fee. To date, Karma Tickets has never received any complaints of this small additional Fee on charges and fans continue to use our website because they appreciate the prices we offer in comparison to other resale ticket websites.</p></>
    },
    { id: 10, title: 'Do you sell tickets for events outside of Toronto?', content: 'Yes! Please use our search button feature on our home page to find tickets to your favourite team, artist, band or venue. Most major events around the world are listed on our website.' },
    { id: 11, title: 'Can I transfer my tickets to anyone after I purchase the tickets?', content: 'Some events do not allow a TRANSFER option. This beyond our control. Most events however can be transferred. Feel free to visit our Contact Us page to reach out to us to get clarification of a certain event and whether or not you will be able to transfer the tickets to someone else if you make a purchase from us.' },

    {
      id: 12, title: 'I was sent tickets via Ticketmaster transfer but when I go to accept the tickets, a pop up error is displayed that reads “OOPS THERE IS AN ERROR” What can I do?', content: `This error is a Ticketmaster website/app glitch and has nothing to do with Karma
Tickets. We suggest you keep going back to the email and trying over and over until
the glitch clicks to work. Fans and season seat holders often have to try 10+ times. It
can be a very frustrating process. You can try to open the link with tickets in a different
browser, switch your wifi to data or vice versa or try to open the link a friends phone.
Again, this is NOT a Karma Tickets error, it is a Ticketmaster glitch. It happens often, be
patient, eventually the glitch clicks and your tickets will appear on your phone, If you
have no luck after 10x of retrying, please reach out to our Customer Care Team by
visiting our CONTACT US page on website.`},
    {
      id: 13, title: 'Can you help me meet the players or get an autograph form a player? Can you do anything special to make our game experience more special or memorable?', content: `We are unable to help fans with these type of personal requests. Often you may see the
Owner of Karma Tickets posting cool experiences he is sharing with fans at games.
Most of the times these situations are random and in the moment. As an online resale
ticket business, it is impossible to assist fans requesting some kind of special
treatment. We suggest you make a post on our Karma Tickets Facebook group and
ask the Karma Tickets community )which has over 40,000 fans form across Canada), if
they have any game day experiences tip for you and your upcoming event. We hope
you have an amazing experience and thank you for choosing Karma Tickets as your
ticket supplier!`},
    {
      id: 14, title: 'What is a RAZZ ?', content: <p>Karma Tickets hosts a variety of razzes (tickets, trips, sports memorabilia + electronics) on a website called Razilia. You can visit <a href="https://razilia.com/whats-razz" className='text-blue-500'><b className='text-blue-500'>https://razilia.com/whats-razz</b></a> to watch a video to learn more about a razz. You can also join our
        Facebook group <a href="https://www.facebook.com/groups/KarmaTickets" className='text-blue-500'><b className='text-blue-500'> Facebook group Karma Tickets</b></a> to follow the many razzes we post on our social media Facebook group. You can read our PINNED post on the Karma Tickets Facebook group that answers many questions about the razzes we host on Razilia.
      </p>
    },
    {
      id: 15, title: 'Are you able to donate tickets to a fundraiser I am hosting?', content: `First off, thanks for thinking about Karma Tickets. Since we cannot donate to every
team, organization, group or committee that asks for a donation, we choose to say NO
to everyone. We often give away free tickets on our Karma Tickets business FB group,

however we do not donate to various fundraisers. Sorry and good luck with your
fundraising campaign.`},
    {
      id: 16, title: 'I accepted the tickets but I went back to the email that was sent to me to get my tickets, the Ticketmaster link reads “Something is not right. This offer may have been claimed or expired.” Who can help me out with this problem?', content: `First off, if you continue to read this Ticketmaster message, it also says “View MY
                                                                                                                                                                                                                                                        EVENTS to view your events and pending transfer offers. All you have to do is click the
                                                                                                                                                                                                                                                        hyperlinked “MY EVENTS” like the message tells you to log into your account or
                                                                                                                                                                                                                                                        retrieve you tickets.
                                                                                                                                                                                                                                                        There is no need to panic. The message explains that the “may have been claimed.”
                                                                                                                                                                                                                                                        The tickets have been claimed because you previously opened the email and clicked
                                                                                                                                                                                                                                                        ACCEPT TICKETS. Since you already ACCEPTED the tickets, you cant accept them
                                                                                                                                                                                                                                                        again. To see your tickets, you must log into your TM account. A fast way to do this is
                                                                                                                                                                                                                                                        follow exactly what the full message tells you to do and click/view MY EVENTS to log
                                                                                                                                                                                                                                                        into your TM account, If you still have an issue, reach out Karma Tickets Customer
                                                                                                                                                                                                                                                        Care Team by visiting our CONTACT US page located at the top and bottom of our
                                                                                                                                                                                                                                                        website.` },
    {
      id: 17, title: 'I was sent tickets but when I go to accept the tickets, a pop up error is displayed that reads “OOPS THERE IS AN ERROR”', content: `This error is a Ticketmaster website/app glitch and has nothing to do with Karma Tickets. We suggest you keep going back to the email and trying over and over until the glitch clicks to work. Fans and season seat holders often have to try 10+ times. It can be a very frustrating process. You can try to open the link with tickets in a different browser, switch your wifi to data or vice versa, or try to open the link on a friend's phone. Again, this is NOT a Karma Tickets error, it is a Ticketmaster glitch. It happens often, be patient, eventually, the glitch clicks, and your tickets will appear on your phone, If you have no luck after 10x of retrying, please reach out to our Customer Care Team by visiting our CONTACT US page on the website.`
    }





  ];

  const handleDropdownClick8 = (id: any) => {
    setSelectedDropdown8(id);
    // Logic to display content based on dropdown id
  };

  
  const dropdownOptions9 = [
    {
      id: 1, title: `If I am located abroad, and/or purchasing tickets to an event taking place abroad,
what currency will I be charged in?`, content: `Karma Tickets is a Canadian owned company. However, to offer fans a large inventory of ticket options for major events around the world, including the opportunity for fans to often score deals leading up to an event, especially on event day, Karma Tickets has partnered up with a USA company. All Credit Card orders on Karma Tickets are processed in USD. For convenience, prices listed on our site are displayed in CAD, including the total in CAD on the checkout page. Regardless of where you are in the world, you will always see prices listed on our site in CAD. You Credit Card will alos always be charged in USD equal to the equivalent value of the CAD total displayed on the check out page. The total in CAD, as well as the total in USD (based on that days exchange rate), are both displayed on our checkout page.` },
    {
      id: 2, title: `When will my credit card be charged?`, content: `As soon as you place an order, a reserve is placed on your credit card to hold the funds for the cost of your purchase. Your card is not officially charged until the seller has confirmed the order, at which point you will receive an order confirmation email.  If the seller is unable to confirm and fulfill your order, the ‘reserved’ funds are released based on your banks policy which is typically within 7 business days.` },
{id:3,title:`What company name will I see on my credit card statement?`,content:`Ticket Group 9724459061`},
{id:4,title:`Are there any additional fees at checkout?`,content:`There are no additional fees added on top of the prices you see displayed on any event listings page. Since your order will be processed by our USA partner, your bank may charge a small international fee. As a Canadian based company that has been operating for years, we rarely receive any negative feedback or concerns from our customers regarding this small international fee you bank may charge. If you are concerned, please feel free to contact your bank for more information prior to placing your order.`}


  ];

  const handleDropdownClick9 = (id: any) => {
    setSelectedDropdown9(id);
    // Logic to display content based on dropdown id
  };

  const dropdownOptions10 = [
    {
      id: 1, title: `What if my event is cancelled or does not occur?`,content: `If an event is cancelled outright, all purchases are refunded in totality (except for delivery costs). If for any reason you do not automatically receive a refund within 5 days, please visit our ‘Contact Us’ page and connect with us via email of phone. Fans will often notice that refunds will be issued the following working day once an event has been labeled as cancelled. It is suggested to EMAIL us, which gives you a more efficient line of communication to follow. If an event is postponed, the venue will determine if the original tickets are still valid, in which case, all sales are final. If tickets need to be purchased again for the newly scheduled event, they will be treated as cancelled, and purchases will be refunded.` },
    {
      id: 2, title: `Will I get a refund if my event is rained out or postponed?`, content: `Refunds will only be issued on cancelled events, which is determined by the venue itself. Tickets for postponed or rescheduled events are usually viewed as valid for the rescheduled/future date and as such refunds are not provided. If tickets are reissued for a rescheduled or postponed event, our Customer Care team will notify you with further instructions on how the tickets will be reissued. If you are want more clarity on your events status as being cancelled or postpones, please visit our ‘Contact Us’ page to connect with our Customer Care team. Emailing our Customer Care team is suggested for this type of communication with our Customer Care team.` },
{id:3,title:`Can I cancel an order I have already placed?`,content:`Unfortunately, no. As stated in our Terms and Conditions, all sales are final.`},
{id:4,title:`Can I exchange tickets for a different quantity or date?`,content:`Unfortunately, not all sales are final.`}


  ];

  const handleDropdownClick10 = (id: any) => {
    setSelectedDropdown10(id);
    // Logic to display content based on dropdown id
  };


  return (
    <Suspense fallback={<Loader />}>
      <div >

        {/* <Header heading={{ head: "FAQs", slug: "" }} loading={loading} setLoading={setLoading} /> */}
        <Header1 heading={{ head: "FAQs", slug: "" }} loading={loading} setLoading={setLoading} />
        {
          !loading && 
          <div className="flex w-full flex-col mb-[30px] ">




          <div className='flex flex-col w-full items-center '>

            <div className={`flex justify-center py-10 text-[#20409A]  text-3xl md:text-4xl font-bold ${oswald.className}`}>Frequently Asked Questions </div>
            <div className='w-[90%] md:w-[80%] lg:w-[70%] font-semibold  text-base text-justify'>
              <span className='text-[#FF6F00]'>Welcome to the Karma Tickets FAQ’s page!</span> This FAQ’s page has been
              created to give fans a complete review of the most commonly asked
              questions when purchasing tickets from Karma Tickets.
              <br />
              <br />

              The first part of
              this FAQ’s page is designed to walk fans through a step-by-step process
              on what to expect once an order has been placed. The second part of our
              FAQ’s covers all other General Questions.
              <br />
              <br />
              Please note, when purchasing tickets on any resale ticket website, especially because we are dealing with an online computer system and many different verified sellers, there are times when an order, for various reasons, experiences a technical issue. Experiencing issues with an order is very rare! However, suppose for some reason there is an issue with your order or ticket delivery. In that case, it is extremely important that you, as a fan purchasing tickets from our website, understand that you must contact our Customer Care team immediately. Our team will assist you and do everything possible to resolve the issue as quickly as we can.
              <br />
              <br />
              If the question you have is not
              on this FAQ’s page, please <Link href="/contactus" className='text-[#20409A]'>click here to visit our CONTACT US </Link> page to connect with our Customer Care
              Team and ask your question.
              <br />
              <br />
              We hope this FAQ’s page gives you all the
              support and guidance that is needed to make your purchase with Karma
              Tickets a smooth, trusting and confident experience.
              <br />
              <br />
              <span className='text-left'>Thank you for your support.</span>
              <br />
              <br />
              <span className='text-left'>- Karma Tickets</span>
            </div>
            <div className='mt-10 flex flex-col w-full md:w-10/12 items-center md:p-0 px-2'>
              <div className='flex flex-col w-full items-start gap-10 mb-4'>

                <div>
                  <div>
                    <div className="text-[#20409A] text-base font-medium font-inter ml-2">
                      FAQ’S AFTER PLACING AN ORDER:
                    </div>
                    <br />

                    <div className="flex">

                      <div className="relative">

                        <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start xl:inline-flex gap-5 hidden">
                          {dropdownOptions.map((option) => (
                            <div
                              key={option.id}
                              className="relative justify-between items-start gap-4 flex cursor-pointer"
                              onClick={() => handleDropdownClick(option.id)}
                            >
                              <div className='flex gap-4'>
                                <div className={`w-6 h-6 rounded-full ${selectedDropdown === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">
                                  {option.title}
                                </div>
                              </div>
                              <IoIosArrowForward />

                              <div
                                className={`absolute left-full top-0 mt-4 ml-[25px] flex min-w-[850px] ${selectedDropdown === option.id ? 'opacity-100' : 'opacity-0 invisible'}`}

                              >
                                <div className="bg-white px-4 shadow overflow-hidden">
                                  <h2 className='font-semibold mb-3'>{option.title}</h2>

                                  <p className="overflow-auto">
                                    {option.content}
                                  </p>

                                </div>
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>





                      <div className="w-screen sm:w-[80vw] px-4  py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 xl:hidden">
                        {dropdownOptions.map((option) => (
                          <Accordion key={option.id} type="single" collapsible className="w-full py-2">
                            <AccordionItem value={option.id.toString()}>
                              <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                <div className='flex gap-2 items-start'>
                                  <div className='mt-1'>
                                    <div className={`w-3 h-3 rounded-full  ${selectedDropdown === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                  </div>
                                  <div>{option.title}</div>
                                </div>
                              </AccordionTrigger>
                              <AccordionContent>
                                <div className="flex flex-col gap-2 pt-2">
                                  <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                </div>
                              </AccordionContent>
                            </AccordionItem>
                          </Accordion>
                        ))}
                      </div>

                    </div>

                  </div>

                </div>
                <br />
                <br />


                <div>
                  <div>
                    <div className="text-[#20409A] text-base font-medium font-inter ml-2">
                      TICKET LISTING INFORMATION:
                    </div>
                    <br />
                    <div className="flex flex-wrap lg:flex-nowrap gap-4">




                      <div className="relative">

                        <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start xl:inline-flex gap-5 hidden">
                          {dropdownOptions7.map((option) => (
                            <div
                              key={option.id}
                              className="relative justify-between items-start gap-4 flex cursor-pointer"
                              onClick={() => handleDropdownClick7(option.id)}
                            >
                              <div className='flex gap-4'>
                                <div className={`w-6 h-6 rounded-full ${selectedDropdown7 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">
                                  {option.title}
                                </div>
                              </div>
                              <IoIosArrowForward />

                              <div
                                className={`absolute left-full top-0 mt-4 ml-[25px] flex min-w-[850px] ${selectedDropdown7 === option.id ? 'opacity-100' : 'opacity-0 invisible'}`}

                              >
                                <div className="bg-white px-4 shadow overflow-hidden">
                                  <h2 className='font-semibold mb-3'>{option.title}</h2>

                                  <p className="overflow-auto">
                                    {option.content}
                                  </p>

                                </div>
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>


                      <div className="w-screen sm:w-[80vw] px-4 py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 xl:hidden">
                        {dropdownOptions7.map((option) => (
                          <Accordion type="single" collapsible className="w-full py-2" key={option.id}>
                            <AccordionItem value={option.id.toString()}>
                              <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                <div className='flex gap-2 items-start'>
                                  <div className='mt-1'>
                                    <div className={`w-3 h-3 rounded-full ${selectedDropdown7 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                  </div>
                                  <div>{option.title}</div>
                                </div>
                              </AccordionTrigger>
                              <AccordionContent>
                                <div className="flex flex-col gap-2 pt-2">
                                  <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                </div>
                              </AccordionContent>
                            </AccordionItem>
                          </Accordion>
                        ))}
                      </div>
                    </div>
                  </div>



                </div>
                <br />
                <br />



                <div>
                  <div>
                    <div >
                      <div className="text-[#20409A] text-base font-medium font-inter ml-2">
                        GENERAL QUESTIONS:
                      </div>
                      <br />
                      <div className="flex">

                       
                        <div className="relative">

                          <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start xl:inline-flex gap-5 hidden">
                            {dropdownOptions8.map((option) => (
                              <div
                                key={option.id}
                                className="relative justify-between items-start gap-4 flex cursor-pointer"
                                onClick={() => handleDropdownClick8(option.id)}
                              >
                                <div className='flex gap-4'>
                                  <div className={`w-6 h-6 rounded-full ${selectedDropdown8 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                  <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">
                                    {option.title}
                                  </div>
                                </div>
                                <IoIosArrowForward />

                                <div
                                  className={`absolute left-full top-0 mt-4 ml-[25px] flex min-w-[850px] ${selectedDropdown8 === option.id ? 'opacity-100' : 'opacity-0 invisible'}`}

                                >
                                  <div className="bg-white px-4 shadow overflow-hidden">
                                    <h2 className='font-semibold mb-3'>{option.title}</h2>

                                    <p className="overflow-auto">
                                      {option.content}
                                    </p>

                                  </div>
                                </div>

                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="w-screen sm:w-[80vw] px-4  py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 xl:hidden">
                          {dropdownOptions8.map((option) => (
                            <Accordion key={option.id} type="single" collapsible className="w-full py-2">
                              <AccordionItem value={option.id.toString()}>
                                <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                  <div className='flex gap-2 items-start'>
                                    <div className='mt-1'>
                                      <div className={`w-3 h-3 rounded-full  ${selectedDropdown8 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                    </div>
                                    <div>{option.title}</div>
                                  </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                  <div className="flex flex-col gap-2 pt-2">
                                    <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            </Accordion>
                          ))}
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                <br />
                <br />
                <div>
                  <div>
                    <div >
                      <div className="text-[#20409A] text-base font-medium font-inter ml-2">
                      Checkout & Payment:
                      </div>
                      <br />
                      <div className="flex">

                       
                        <div className="relative">

                          <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start xl:inline-flex gap-5 hidden">
                            {dropdownOptions9.map((option:any) => (
                              <div
                                key={option.id}
                                className="relative justify-between items-start gap-4 flex cursor-pointer"
                                onClick={() => handleDropdownClick9(option.id)}
                              >
                                <div className='flex gap-4'>
                                  <div className={`w-6 h-6 rounded-full ${selectedDropdown9 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                  <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">
                                    {option.title}
                                  </div>
                                </div>
                                <IoIosArrowForward />

                                <div
                                  className={`absolute left-full top-0 mt-4 ml-[25px] flex min-w-[850px] ${selectedDropdown9 === option.id ? 'opacity-100' : 'opacity-0 invisible'}`}

                                >
                                  <div className="bg-white px-4 shadow overflow-hidden">
                                    <h2 className='font-semibold mb-3'>{option.title}</h2>

                                    <p className="overflow-auto">
                                      {option.content}
                                    </p>

                                  </div>
                                </div>

                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="w-screen sm:w-[80vw] px-4  py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 xl:hidden">
                          {dropdownOptions9.map((option:any) => (
                            <Accordion key={option.id} type="single" collapsible className="w-full py-2">
                              <AccordionItem value={option.id.toString()}>
                                <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                  <div className='flex gap-2 items-start'>
                                    <div className='mt-1'>
                                      <div className={`w-3 h-3 rounded-full  ${selectedDropdown9 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                    </div>
                                    <div>{option.title}</div>
                                  </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                  <div className="flex flex-col gap-2 pt-2">
                                    <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            </Accordion>
                          ))}
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                <br />
                <br />
                <div>
                  <div>
                    <div >
                      <div className="text-[#20409A] text-base font-medium font-inter ml-2">
                      Cancellation Policy and Information:
                      </div>
                      <br />
                      <div className="flex">

                       
                        <div className="relative">

                          <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start xl:inline-flex gap-5 hidden">
                            {dropdownOptions10.map((option) => (
                              <div
                                key={option.id}
                                className="relative justify-between items-start gap-4 flex cursor-pointer"
                                onClick={() => handleDropdownClick10(option.id)}
                              >
                                <div className='flex gap-4'>
                                  <div className={`w-6 h-6 rounded-full ${selectedDropdown10 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                  <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">
                                    {option.title}
                                  </div>
                                </div>
                                <IoIosArrowForward />

                                <div
                                  className={`absolute left-full top-0 mt-4 ml-[25px] flex min-w-[850px] ${selectedDropdown10 === option.id ? 'opacity-100' : 'opacity-0 invisible'}`}

                                >
                                  <div className="bg-white px-4 shadow overflow-hidden">
                                    <h2 className='font-semibold mb-3'>{option.title}</h2>

                                    <p className="overflow-auto">
                                      {option.content}
                                    </p>

                                  </div>
                                </div>

                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="w-screen sm:w-[80vw] px-4  py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 xl:hidden">
                          {dropdownOptions10.map((option) => (
                            <Accordion key={option.id} type="single" collapsible className="w-full py-2">
                              <AccordionItem value={option.id.toString()}>
                                <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                  <div className='flex gap-2 items-start'>
                                    <div className='mt-1'>
                                      <div className={`w-3 h-3 rounded-full  ${selectedDropdown10 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                    </div>
                                    <div>{option.title}</div>
                                  </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                  <div className="flex flex-col gap-2 pt-2">
                                    <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            </Accordion>
                          ))}
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                <br />
                <br />
                <br />
                <br />
               




                <div>
                  <div>
                    <div>
                      <div className="text-blue-950 text-base font-medium font-inter ml-2">
                        <Link href="https://www.facebook.com/groups/KarmaTickets" className='text-[#20409A]'>THE KARMA TICKETS FACEBOOK GROUP </Link>
                        is a very
                        active, trusting and knowledgeable community. We
                        have fans from all Canada in our group that have an
                        abundance of experience. Please note, if you post a
                        question on our Facebook group, posts must be
                        approved and there is no guarantee of how quickly
                        your post will be approved and live in the group for
                        members to help. The following are examples of
                        question you can post in the group and ask our
                        members:
                        <br />
                        <br />
                        Where is the best place to park?
                        <br />
                        <br />
                        How early should I go to Skydome/Rogers Centre to make sure I get a giveaway?
                        <br />
                        <br />
                        Can I bring food into a venue?
                        <br />
                        <br />
                        Can I bring a baby stroller into a venue?
                        <br />
                      </div>
                      <br />
                      {/* <div className="flex">

                        <div className="w-140 p-4 bg-slate-50 shadow flex-col justify-start items-start lg:inline-flex gap-y-5 hidden">
                          {dropdownOptions9.map((option) => (
                            <div key={option.id} className="justify-start items-start gap-4 flex cursor-pointer" onClick={() => handleDropdownClick9(option.id)}>
                              <div className='flex gap-4'>
                                <div className={`w-6 h-6 rounded-full ${selectedDropdown9 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                                <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">{option.title}</div>
                              </div>
                              <IoIosArrowForward />
                            </div>
                          ))}
                        </div>


                        {dropdownOptions9.map((option) => (
                          <div
                            key={option.id}
                            className={`overflow-hidden transition-opacity duration-500 ${selectedDropdown9 === option.id ? 'opacity-100' : 'opacity-0 invisible'} dropdown-content-container`}>
                            {selectedDropdown9 === option.id && (
                              <div className="bg-white px-4 shadow">
                                <div className='font-semibold mb-3'>{option.title}</div>
                                {option.content}
                              </div>
                            )}
                          </div>
                        ))}
                        <div className="w-screen sm:w-[80vw] px-4  py-0.5 bg-slate-50 text-start shadow flex-col justify-start items-start inline-flex gap-y-5 lg:hidden">
                          {dropdownOptions9.map((option) => (
                            <Accordion type="single" collapsible className="w-full py-2">
                              <AccordionItem value={option.id.toString()}>
                                <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                                  <div className='flex gap-2 items-start'>
                                    <div className='mt-1'>
                                      <div className={`w-3 h-3 rounded-full  ${selectedDropdown9 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                                    </div>
                                    <div>{option.title}</div>
                                  </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                  <div className="flex flex-col gap-2 pt-2">
                                    <div className="text-[14px] font-normal ml-1">{option.content}</div>
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            </Accordion>
                          ))}
                        </div>
                      </div> */}

                    </div>

                  </div>

                </div>
                {/* <Link href="https://www.facebook.com/groups/KarmaTickets" className='text-[#20409A] text-center justify-center items-center ml-[500px]'><b>Click here to visit our KARMA TICKETS FACEBOOK GROUP !</b></Link> */}


                {/* <div>
                <div>
                  <div>
                    <div className="text-zinc-900 text-3xl font-semibold font-inter  ml-2">
                      Checkout & Payment
                    </div>
                    <br />
                    <div className="flex">

                      <div className="w-140 px-4   py-0.5 bg-slate-50 shadow flex-col justify-start items-start md:inline-flex gap-y-5 hidden">
                        {dropdownOptions4.map((option) => (
                          <div key={option.id} className="justify-start items-start gap-4 flex cursor-pointer" TICKET LISTING INFORMATION:={() => handleDropdownClick4(option.id)}>
                          <div className='flex gap-4'>
                          <div className={`w-6 h-6 rounded-full ${selectedDropdown4 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                          <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">{option.title}</div>
                          </div>
                          <IoIosArrowForward />
                        </div>
                        ))}
                      </div>


                      {dropdownOptions4.map((option) => (
                        <div
                          key={option.id}
                          className={`overflow-hidden transition-opacity duration-500 ${selectedDropdown4 === option.id ? 'opacity-100' : 'opacity-0 invisible'} dropdown-content-container`}>
                          {selectedDropdown4 === option.id && (
                            <div className="bg-white px-4 shadow">
                              <div className='font-semibold mb-3'>{option.title}</div>
                              {option.content}
                            </div>
                          )}
                        </div>
                      ))}
                      <div className="w-140 px-4  py-0.5 bg-slate-50 shadow flex-col justify-start items-start inline-flex gap-y-5 md:hidden">
                      {dropdownOptions4.map((option) => (
                        <Accordion type="single" collapsible className="w-full py-2">
                        <AccordionItem  value={option.id.toString()}>
                        <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                            <div className='flex gap-2 items-start'>
                              <div className='mt-1'>
                              <div className={`w-3 h-3 rounded-full  ${selectedDropdown4 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                              </div>
                              <div>{option.title}</div>
                              </div>
                            </AccordionTrigger>
                            <AccordionContent>
                              <div className="flex flex-col gap-2 pt-2">
                                <div className="text-[14px] font-normal ml-1">{option.content}</div>
                              </div>
                            </AccordionContent>
                          </AccordionItem>
                        </Accordion>
                      ))}
                      </div>
                    </div>

                  </div>

                </div>

              </div> */}


                {/* <div>
                <div>
                  <div >
                    <div className="text-zinc-900 text-3xl font-semibold font-inter  ml-2">
                      General Ticket Information
                    </div>
                    <br />
                    <div className="flex">

                      <div className="w-140 px-4  py-0.5 bg-slate-50 shadow flex-col justify-start items-start md:inline-flex gap-y-5 hidden">
                        {dropdownOptions5.map((option) => (
                          <div key={option.id} className="justify-start items-start gap-4 flex cursor-pointer" onClick={() => handleDropdownClick5(option.id)}>
                          <div className='flex gap-4'>
                          <div className={`w-6 h-6 rounded-full ${selectedDropdown5 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                          <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">{option.title}</div>
                          </div>
                          <IoIosArrowForward />
                        </div>
                        ))}
                      </div>


                      {dropdownOptions5.map((option) => (
                        <div
                          key={option.id}
                          className={`overflow-hidden transition-opacity duration-500 ${selectedDropdown5 === option.id ? 'opacity-100' : 'opacity-0 invisible'} dropdown-content-container`}>
                          {selectedDropdown5 === option.id && (
                            <div className="bg-white px-4 shadow">
                              <div className='font-semibold mb-3'>{option.title}</div>
                              {option.content}
                            </div>
                          )}
                        </div>
                      ))}
                      <div className="w-140 px-4  py-0.5 bg-slate-50 shadow flex-col justify-start items-start inline-flex gap-y-5 md:hidden">
                      {dropdownOptions5.map((option) => (
                        <Accordion type="single" collapsible className="w-full py-2">
                        <AccordionItem  value={option.id.toString()}>
                        <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                            <div className='flex gap-2 items-start'>
                              <div className='mt-1'>
                              <div className={`w-3 h-3 rounded-full  ${selectedDropdown5 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                              </div>
                              <div>{option.title}</div>
                              </div>
                            </AccordionTrigger>
                            <AccordionContent>
                              <div className="flex flex-col gap-2 pt-2">
                                <div className="text-[14px] font-normal ml-1">{option.content}</div>
                              </div>
                            </AccordionContent>
                          </AccordionItem>
                        </Accordion>
                      ))}
                      </div>
                    </div>

                  </div>

                </div>

              </div> */}


                {/* <div>
                <div>
                  <div>
                    <div className="text-zinc-900 text-3xl font-semibold font-inter ml-2">
                      Cancellation Policy and Information
                    </div>
                    <br />
                    <div className="flex">

                      <div className="w-140 px-4  py-0.5 bg-slate-50 shadow flex-col justify-start items-start md:inline-flex gap-y-5 hidden">
                        {dropdownOptions6.map((option) => (
                          <div key={option.id} className="justify-start items-start gap-4 flex cursor-pointer" onClick={() => handleDropdownClick6(option.id)}>
                          <div className='flex gap-4'>
                          <div className={`w-6 h-6 rounded-full ${selectedDropdown6 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`} />
                          <div className="md:w-96 w-48 text-black text-base font-normal font-inter leading-normal">{option.title}</div>
                          </div>
                          <IoIosArrowForward />
                        </div>
                        ))}
                      </div>


                      {dropdownOptions6.map((option) => (
                        <div
                          key={option.id}
                          className={`overflow-hidden transition-opacity duration-500 ${selectedDropdown6 === option.id ? 'opacity-100' : 'opacity-0 invisible'} dropdown-content-container`}>
                          {selectedDropdown6 === option.id && (
                            <div className="bg-white px-4 shadow">
                              <div className='font-semibold mb-3'>{option.title}</div>
                              {option.content}
                            </div>
                          )}
                        </div>
                      ))}
                      <div className="w-140 px-4   py-0.5 bg-slate-50 shadow flex-col justify-start items-start inline-flex gap-y-5 md:hidden">
                      {dropdownOptions6.map((option) => (
                        <Accordion type="single" collapsible className="w-full py-2">
                        <AccordionItem  value={option.id.toString()}>
                            <AccordionTrigger className='flex items-start justify-between gap-2 text-start text-sm cursor-pointer'>
                            <div className='flex gap-2 items-start'>
                              <div className='mt-1'>
                              <div className={`w-3 h-3 rounded-full  ${selectedDropdown6 === option.id ? 'bg-indigo-500' : 'bg-blue-200'}`}></div>
                              </div>
                              <div>{option.title}</div>
                              </div>
                            </AccordionTrigger>
                            <AccordionContent>
                              <div className="flex flex-col gap-2 pt-2">
                                <div className="text-[14px] font-normal ml-1">{option.content}</div>
                              </div>
                            </AccordionContent>
                          </AccordionItem>
                        </Accordion>
                      ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              </div>
            </div>
          </div>
          <br />
          {/* <Link href="https://www.facebook.com/groups/KarmaTickets" className='text-[#20409A] text-center justify-center items-center ml-[300px]'><b>Click here to visit our KARMA TICKETS FACEBOOK GROUP !</b></Link> */}
          <div className="flex justify-center items-center text-center">
            <Link href="https://www.facebook.com/groups/KarmaTickets" className="text-[#20409A] text-center mx-4 md:mx-8 lg:mx-12">
              <b>Click here to visit our KARMA TICKETS FACEBOOK GROUP!</b>
            </Link>
          </div>



        </div>
        }
        
        <Footer />


      </div>
    </Suspense>
  )
}

export default Faq
